import React, { Component } from 'react'
import Modal from 'react-modal'
import RestApiUtils from '../../../../apiclient/moebli/RestApiUtils.js'
import RepaymentInterestModalUI from './RepaymentInterestModalUI.js'

class RepaymentInterestModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      submitted: false,
      status: null,
      interestAmount: this.props.selectedRepayment ? this.props.selectedRepayment.interestAmountF : '',
      interestAmountError: null,
    }
  }

  render() {
    return (
      <RepaymentInterestModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // modes
        updateMode={this.props.updateMode}
        submitted={this.state.submitted}
        status={this.state.status}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.onCancelClick}
        // form fields
        interestAmount={this.state.interestAmount}
        onInterestAmountChange={(event) => { this.setState({ interestAmount: event.target.value }) }}
        interestAmountError={this.state.interestAmountError}
        setInterestAmountError={(error) => { this.setState({ interestAmountError: error }) }}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    Modal.setAppElement('body')
  }

  componentDidUpdate(prevProps) {
    let repayment = this.props.selectedRepayment
    if (!repayment ||
      prevProps.selectedRepayment && prevProps.selectedRepayment.scheduledDate === repayment.scheduledDate)
      return

    if (repayment.status == 'paid' || repayment.status == 'initiated') {
      this.setState({
        status: repayment.status,
        submitted: false,
        errorList: null
      })
    }

    if (repayment.status == 'unpaid') {
      this.setState({
        interestAmount: '',
        status: repayment.status,
        submitted: false,
        errorList: null
      })
    }
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.put(this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/repayments/scheduledDates/${this.props.selectedRepayment.scheduledDateISO}/interestAdjusted/pay`,
      this.onSubmitCallback, {
      interestAdjustedF: this.state.interestAmount
    }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onCancelClick()
        this.props.onRefreshClick('noBusy')
      }, 100)
    }
  }

  onCancelClick = () => {
    this.setState({
      errorList: null,
      submitted: false,
    })
    this.props.onCancelClick()
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default RepaymentInterestModalSF
